import { render, staticRenderFns } from "./fccGenero.vue?vue&type=template&id=090045de"
import script from "./fccGenero.vue?vue&type=script&lang=js"
export * from "./fccGenero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports